export interface DemoPlacementPoint {
  x: number
  y: number
}

export type DemoPlacementPhase = 'idle' | 'aiming' | 'pending'

export interface DemoPlacementState {
  phase: DemoPlacementPhase
  position: DemoPlacementPoint | null
  valid: boolean
}

export function createDemoPlacementState(): DemoPlacementState {
  return { phase: 'idle', position: null, valid: false }
}

export function beginDemoPlacement(_state: DemoPlacementState): DemoPlacementState {
  return { phase: 'aiming', position: null, valid: false }
}

export function moveDemoPlacement(
  state: DemoPlacementState,
  position: DemoPlacementPoint,
  valid: boolean,
): DemoPlacementState {
  if (state.phase !== 'aiming') return state
  return {
    phase: 'aiming',
    position: { x: Math.round(position.x), y: Math.round(position.y) },
    valid,
  }
}

export function lockDemoPlacement(state: DemoPlacementState): DemoPlacementState {
  if (state.phase !== 'aiming' || !state.valid || !state.position) return state
  return { ...state, phase: 'pending' }
}

export function cancelDemoPlacement(_state: DemoPlacementState): DemoPlacementState {
  return createDemoPlacementState()
}

export function confirmDemoPlacement(state: DemoPlacementState): {
  state: DemoPlacementState
  placement: DemoPlacementPoint | null
} {
  return {
    state: createDemoPlacementState(),
    placement: state.phase === 'pending' && state.valid ? state.position : null,
  }
}
